import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { TextLoca } from "../generic/text/TextLoca";
import { AnimationLevelUp } from "./level-up-animation/AnimationLevelUp";
import { LevelUpCharacters } from "./LevelUpCharacters";
export var DialogGenericLevelUp = function (_a) {
    var level = _a.level, onClose = _a.onClose, children = _a.children;
    return (React.createElement("div", null,
        React.createElement(AnimationLevelUp, null),
        React.createElement(DialogWrapper, { titleLocaId: IdLoca.levelUpDialog_title, onClose: onClose, className: IdStyles.ModalBackgroundLevelUp },
            React.createElement(LevelUpCharacters, null),
            React.createElement("div", { className: "level-up" },
                React.createElement("div", { className: "level-up_level" },
                    React.createElement("div", { className: "level-up_level_animation" }),
                    React.createElement(FontWithOutline, { style: IdStyles.HeadlineOne }, level)),
                React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around h100" },
                    children,
                    React.createElement(ButtonPrimary, { onClick: onClose },
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.hooray })))))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/DialogGenericLevelUp.tsx
// module id = 909
// module chunks = 3